import {inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {SessionResult} from '../core/models';

@Injectable({
  providedIn: 'root'
})
export class ApiSession {
  baseUrl = '/middleware';
  private http = inject(HttpClient);

  initializeSession(tableId: string, customerName: string): Observable<SessionResult> {
    return this.http.post<SessionResult>(`${this.baseUrl}/restaurant/sessions/init`, {
      tableId,
      customerName
    });
  }

  reloadApp(customerId: string | null): Observable<SessionResult> {
    return this.http.get<SessionResult>(`${this.baseUrl}/restaurant/sessions/${customerId}/reload`);
  }

}
